//EventDetails.jsx:

import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../styles/eventDetails.css";
import { eventRegistrationAction, fetchEventDataAction } from "../redux/slices/eventSlices";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import UserNav from "./UserNav";
import TicketPopUp from './TicketPopUp';
import '../styles/TicketPopUp.css';

const EventDetails = () => {
    const dispatch = useDispatch();
    const { eventId } = useParams();
    const [isPaused, setIsPaused] = useState(false);
    const [showPopup, setShowPopup] = useState(false); // State to control popup visibility
    const sliderRef = useRef(null);

    const UserstoreData = useSelector((store) => store?.users);
    const { user } = UserstoreData;

    useEffect(() => {
        const data = {
            teamId: user?.teamDetails,
            userId: user?.id,
            id: eventId,
        };
        dispatch(fetchEventDataAction(data));
    }, [dispatch, eventId, user?.teamDetails, user?.id]);

    const storeData = useSelector((store) => store?.event);
    const { event, time: pastTime, registered } = storeData;

    useEffect(() => {
        const slider = sliderRef?.current;
        let animationId;

        const animate = () => {
            if (slider) {
                if (!isPaused) {
                    slider.scrollLeft = slider.scrollLeft + 1;
                    if (slider.scrollLeft >= slider.scrollWidth - slider.clientWidth) {
                        slider.scrollLeft = 0;
                    }
                }
            }
            animationId = requestAnimationFrame(animate);
        };

        animationId = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationId);
    }, [isPaused]);

    const handleMouseEnter = () => setIsPaused(true);
    const handleMouseLeave = () => setIsPaused(false);

    const date = new Date(event?.startTime);

    const registerAction = () => {
        const data = {
            eventId: eventId,
        };
        const data1 = {
            teamId: user?.teamDetails,
            userId: user?.id,
            id: eventId,
        };

       

        dispatch(eventRegistrationAction(data));
        dispatch(fetchEventDataAction(data1));
         console.log(event.ticket);
       
        if (!event?.isPaid) {
            setShowPopup(true);
        }
    };

    const downloadTicket = async () => {
        const response = await fetch(event.ticket);
        const blob = await response.blob();
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "ticket.jpg";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };
    

    const time = date.toLocaleDateString('en-Us', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    const images = [];
    for (let i = 2; i <= 8; i++) {
        if (event?.[`image${i}`]) {
            images.push(event[`image${i}`]);
        }
    }

    const TicketPopUp = () => {
    
  
      const closeModal = () => {
          document.getElementById("popup-modal").style.display = "none";
      };
  
      return (
          <div id="popup-modal" className="modal-overlay">
              <div className="modal-box">
                  <h2 className="modal-title">Yayy! Registration Successful</h2>
                 
                    <button className="modal-button download" onClick={downloadTicket}>Download Ticket</button>
               
                  <button onClick={closeModal} className="modal-button close">
                      Close
                  </button>
              </div>
          </div>
      );
  };


    return (
        <>
            <UserNav />
            <div id="main1">
                <div id="content-wrapper">
                    <div id="event-name">
                        <div>{event?.name}</div>
                    </div>
                    <div id="poster">
                        <div id="event-image">
                            <img src={event?.image1} alt="Event poster" />
                        </div>
                        <div id="event-details">
                            <div>{time}</div>
                            <div>{event?.keyword}</div>
                            <div>
                                {user ? (
                                    pastTime === "past" ? (
                                        <button type="button" style={{ backgroundColor: "gray" }}>Registration closed</button>
                                    ) : registered ? (
                                      <div>
                                        <button type="button">Registered</button>
                                              
                                        </div>
                                    ) : event?.isPaid ? (
                                        <Link to={event?.paidFormLink}><button type="button">Register</button></Link>
                                    ) : (
                                        <button type="button" onClick={registerAction}>Register</button>
                                    )
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div id="description">
                        <p dangerouslySetInnerHTML={{ __html: event?.description }} />
                    </div>
                </div>
            </div>

            {images.length > 0 && (
                <div className="clients">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="sec-heading">
                                    <h2>Event Glimpses</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div
                                    className="slider-container"
                                    ref={sliderRef}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    {images.map((image, index) => (
                                        <div key={index} className="item box">
                                            <img alt={`Event ${index + 1}`} className="client-img" src={image} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            
            {showPopup && <TicketPopUp />}
        </>
    );
};

export default EventDetails;
